import { computed, watch } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

export const DEFAULT_ACCENT_COLOR = '#2781F6';

const normalizeHexColor = color => {
  if (typeof color !== 'string' || !/^#[0-9a-f]{6}$/i.test(color)) {
    return DEFAULT_ACCENT_COLOR;
  }

  return color.toUpperCase();
};

const applyAccentColorToDOM = color => {
  const normalizedColor = normalizeHexColor(color);
  const red = parseInt(normalizedColor.slice(1, 3), 16);
  const green = parseInt(normalizedColor.slice(3, 5), 16);
  const blue = parseInt(normalizedColor.slice(5, 7), 16);

  document.documentElement.style.setProperty(
    '--brand-color',
    `${red} ${green} ${blue}`
  );
};

export const useAccentColor = () => {
  const { uiSettings, updateUISettings } = useUISettings();
  const currentAccentColor = computed(() =>
    normalizeHexColor(uiSettings.value?.accent_color)
  );

  const updateAccentColor = color => {
    const normalizedColor = normalizeHexColor(color);
    applyAccentColorToDOM(normalizedColor);
    updateUISettings({ accent_color: normalizedColor });
  };

  watch(currentAccentColor, applyAccentColorToDOM, { immediate: true });

  return {
    currentAccentColor,
    updateAccentColor,
  };
};

export default useAccentColor;
